import React from "react";

// WW-172 · ingest found an existing event. Default is update (already applied
// server side: empty fields filled, source link added); create anyway is for real repeats.
export const IngestMatchDialog = ({ match, busy, onUpdate, onCreateAnyway }) => (
  <div data-testid="ingest-match-dialog" role="dialog"
       className="fixed inset-0 z-[90] flex items-center justify-center p-4" style={{ background: "rgba(26,26,48,0.55)" }}>
    <div className="w-full max-w-md rounded-xl border bg-white p-5" style={{ borderColor: "#E4D7C0" }}>
      <p className="text-[11px] font-bold uppercase tracking-wider" style={{ color: "#8A8171" }}>already on watu wako</p>
      <p data-testid="ingest-match-note" className="mt-2 text-[15px] font-semibold lowercase" style={{ color: "#1A1A30" }}>
        {match.note}
      </p>
      <p data-testid="ingest-match-filled" className="mt-2 text-[12px] lowercase" style={{ color: "#5A5449" }}>
        {match.filled_fields?.length
          ? `filled empty fields: ${match.filled_fields.join(", ")}. nothing a person edited was changed.`
          : "no empty fields to fill. the new source link was added."}
      </p>
      <div className="mt-4 flex gap-2">
        <button data-testid="ingest-match-update" onClick={onUpdate} disabled={busy}
          className="h-10 flex-1 rounded-full text-[12px] font-bold uppercase tracking-wider"
          style={{ background: "#FFD60A", color: "#1A1A30", border: "2px solid #1A1A30" }}>
          update it
        </button>
        <button data-testid="ingest-match-create-anyway" onClick={onCreateAnyway} disabled={busy}
          className="h-10 flex-1 rounded-full bg-white text-[12px] font-bold uppercase tracking-wider"
          style={{ color: "#1A1A30", border: "2px solid #1A1A30", opacity: busy ? 0.6 : 1 }}>
          {busy ? "creating..." : "create anyway"}
        </button>
      </div>
    </div>
  </div>
);
